import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { ActivatedRoute } from '@angular/router';
import { NumberCardsService } from '../number-cards.service';
import {TopicService } from '../topic.service';
import { Location } from '@angular/common';

export abstract class TSuperExerciseComponent extends GeneralTeacherComponent {
  representation: string;
  representationSpec: any = undefined;
  helptext: string = "symbols";
  cards: number[] = [];
  constructor(protected activatedRoute: ActivatedRoute, protected numberCardsService: NumberCardsService, protected topicService: TopicService) {
    super(topicService, activatedRoute);
  }


  /** sets information based on configuration */
  setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
    this.representation = this.configuration.typespecifics.representation;
    this.helptext = this.configuration.typespecifics.showHelp;
    if (this.representation == "nary") {
      this.representationSpec = this.configuration.typespecifics.representationSpec;
    }
    if (this.representation == "personal") {
      this.representationSpec = this.configuration.typespecifics.representationSpec.toString();
    }
  }

  reset(){
    super.reset();
    this.representation = undefined;
    this.representationSpec = undefined;
    this.helptext = "symbols";
  }

   /** computes and sets the cards */
   onChangeRepr() {
    if(!this.representationDefined()){
      return;
    }
    let reprSpec = this.representationSpec;
    if(this.representation == "personal"){
      reprSpec = this.representationSpec.split(",");
    }
    this.cards = this.numberCardsService.getCards(this.representation, reprSpec);
  }

 /** checks, whether everything for the representation is defined */
 representationDefined(): boolean {
  if (this.representation == "" || this.representation == null || this.representation == undefined) {
    return false;
  }
  if (this.representation == "nary" || this.representation == "personal") {
    if (this.representationSpec == undefined || this.representationSpec == null || this.representationSpec < 1) {
      return false;
    }
  }
  if (this.representation == "personal") {
    if (!this.numberCardsService.checkValidCards(this.representationSpec)){
      return false;
    }
  }
  return true;
}

  generateDefinition(): any {
    let definition: any = {};
    definition.title = this.title;
    definition.type = this.type;
    definition.image = "./assets/images/dataRepresentation.png";
    definition.description = this.description;
    if (this.id == undefined || this.id == null) {
        definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;

    definition.typespecifics = {};
    definition.typespecifics.representation = this.representation;
    if (this.representation != "nary" && this.representation != "personal") {
      this.representationSpec = "";
    }
    if (this.representation == "nary") {
      definition.typespecifics.representationSpec = this.representationSpec;
    }
    if (this.representation == "personal") {
      let cards = [];
      for (let card of this.representationSpec.toString().split(",")) {
        cards.push(+card);
      }
      definition.typespecifics.representationSpec = cards;
    }
    definition.typespecifics.showHelp = this.helptext;
    
    return definition;
  }

  generate(){
    let representationId = Math.floor(Math.random() * 4);
    switch (representationId) {
      case 0:
        this.representation = "nary";
        this.representationSpec = Math.floor(Math.random() * 8 + 2);
        break;
      case 1:
        this.representation = "hexadecimal";
        break;
      case 2:
        this.representation = "roman";
        break;
      case 3:
        this.representation = "etruscan";
        break;
    }
  }

  maxNumber():number{
    if(this.representationDefined()){
    switch (this.representation) {
      case "nary": return this.cards[0] * this.representationSpec; 
      case "roman": return 1000;
      case "etruscan": return 36000;
      case "hexadecimal": return 4096;
      case "personal": return this.cards[0] * 10;
    }
  } else {
    return 100000;
  }
  }
}
